import {Button, Form, Radio, Row, Select, Switch} from 'antd';
import React from "react";
import {IFieldOptionsEditorProps} from "../FieldOptionsEditor";
import {CodeOutlined, MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import LocaleText from "../../../../settings/dictionary/LocaleText";
import TranslationInput from "../../../../../shared/input/TranslationInput";
import Utils from "../../../../../../utils";

export interface IFieldSelectOptions {
    selectOptions?: string[]
    multiple?: boolean
    selectMode?: "radio" | "select" | "auto"
}

interface IProps extends IFieldOptionsEditorProps {

}

class FieldSelectOptionsEditor extends React.Component<IProps> {

    render() {
        const {buildFieldName} = this.props

        return (
            <div>
                <Form.List name={buildFieldName('selectOptions')}>
                    {(fields, {add, remove}) => <div>
                        {fields.map((field) => (
                            <Form.Item
                                required={false} key={field.key}>
                                <Row align={'middle'}>
                                    <Form.Item {...field} validateTrigger={['onChange', 'onBlur']}
                                               rules={[
                                                   {
                                                       required: true,
                                                       whitespace: true,
                                                       message: <LocaleText
                                                           code={'configuration.field.select.options.required'}
                                                           fallback={'Zadejte název možnosti nebo toto pole smažte.'}/>,
                                                   },
                                               ]}
                                               noStyle
                                    >
                                        <TranslationInput
                                            code={'configuration.field.select.options.option.' + Utils.uuid()}
                                            preserveCode={true} className={'mr-3'}/>
                                    </Form.Item>
                                    {fields.length > 1 ? (
                                        <MinusCircleOutlined className="dynamic-delete-button"
                                                             onClick={() => remove(field.name)}/>
                                    ) : null}

                                </Row>
                            </Form.Item>
                        ))}
                        <Form.Item label={<LocaleText code={'configuration.field.select.options.options'}
                                                      fallback={'Možnosti'}/>}>
                            <Button type="dashed" onClick={() => add()} style={{width: '60%'}}>
                                <PlusOutlined/>
                            </Button>
                        </Form.Item>
                    </div>
                    }
                </Form.List>
                <Form.Item name={buildFieldName('multiple')} label={<LocaleText code={'configuration.field.select.options.multiple'} fallback={'Vícenásobný výběr'}/>} valuePropName={'checked'}>
                    <Switch/>
                </Form.Item>
                <Form.Item label={<LocaleText code={'configuration.field.select.option.mode'} fallback={'Typ'}/>} name={buildFieldName('selectMode')} rules={[{required: true}]} initialValue={'auto'}>
                    <Select>
                        <Select.Option value={'auto'}>
                            <Row justify={"space-between"} align={"middle"}>
                                <LocaleText code={'configuration.field.select.option.mode.auto'} fallback={'Automatický'}/>
                                <CodeOutlined style={{fontSize: 'large'}}/>
                            </Row>
                        </Select.Option>
                        <Select.Option value={'select'}>
                            <Row justify={"space-between"} align={"middle"}>
                                <LocaleText code={'configuration.field.select.option.mode.select'} fallback={'Volba'}/>
                                <Select className={'d-inline-block w-auto'} defaultValue={1} size={"small"}>
                                    <Select.Option value={1}>test</Select.Option>
                                </Select>
                            </Row>
                        </Select.Option>
                        <Select.Option value={'radio'}>
                            <Row justify={"space-between"} align={"middle"}>
                                <LocaleText code={'configuration.field.select.option.mode.radio'} fallback={'Přepínač'}/>
                                <Radio className={'d-flex align-items-center'}>Test</Radio>
                            </Row>
                        </Select.Option>
                    </Select>
                </Form.Item>
            </div>
        )
    }
}


export default FieldSelectOptionsEditor